var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_collega",
    "data-name": "icona collega",
    d: "M3.4,14A3.357,3.357,0,0,1,1.005,13a3.355,3.355,0,0,1-1-2.517,4.033,4.033,0,0,1,1.27-2.7L2.7,6.342a.547.547,0,1,1,.775.772L2.046,8.551a2.5,2.5,0,0,0-.267,3.671,2.5,2.5,0,0,0,3.67-.266L7.415,9.99a2.963,2.963,0,0,0,.95-1.967,2.272,2.272,0,0,0-.684-1.7,2.42,2.42,0,0,0-.512-.393.547.547,0,1,1,.541-.95,3.515,3.515,0,0,1,.744.57,3.355,3.355,0,0,1,1,2.517,4.033,4.033,0,0,1-1.27,2.7L6.223,12.73A4.033,4.033,0,0,1,3.523,14Zm3.639-5.18a.547.547,0,0,0-.2-.746,2.42,2.42,0,0,1-.512-.393,2.5,2.5,0,0,1,.266-3.67L8.55,2.047a2.5,2.5,0,0,1,3.67-.266,2.5,2.5,0,0,1-.267,3.671L10.522,6.889a.547.547,0,1,0,.775.772l1.43-1.436A4.033,4.033,0,0,0,14,3.525a3.355,3.355,0,0,0-1-2.517,3.355,3.355,0,0,0-2.517-1,4.033,4.033,0,0,0-2.7,1.27L5.811,3.239a4.033,4.033,0,0,0-1.27,2.7,3.355,3.355,0,0,0,1,2.517,3.515,3.515,0,0,0,.744.57.547.547,0,0,0,.746-.2Z",
    transform: "translate(0.001 -0.002)",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.f3bd31fceca8881b0e7b6b8a155d58f7.svg";
export { ForwardRef as ReactComponent };